import { CellProps, Renderer } from "react-table";

export const EmailCell: <T extends object>() => Renderer<CellProps<T, unknown>> = 
    () => {
        return (props) => props.value ? (
            <a href={`mailto:${props.value}`}>
                {props.value as string}
            </a>
        ) : (<></>)
}